<template>
  <div class="platform-panel-loading" role="status" aria-live="polite" aria-busy="true">
    <div class="loading-card">
      <span class="spinner" aria-hidden="true"></span>
      <p>{{ label }}</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, default: '正在加载数据…' },
});
</script>

<style scoped>
.platform-panel-loading {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(248, 250, 252, 0.78);
  backdrop-filter: blur(2px);
}

.loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 22px 28px;
  border-radius: 16px;
  border: 1px solid var(--border-color, #e2e8f0);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #e2e8f0;
  border-top-color: #7c3aed;
  border-radius: 50%;
  animation: platform-panel-spin 0.8s linear infinite;
}

.loading-card p {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

@keyframes platform-panel-spin {
  to { transform: rotate(360deg); }
}
</style>
